import { Users, Sword, Clock, Server, Star, Gamepad2 } from 'lucide-react'
import { useSoundEffects } from '../hooks/useSoundEffects'
export function AboutPage() {
  const { playHoverSound } = useSoundEffects()
  
  return (
    <div className="min-h-screen pt-20 pb-8 relative">

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Hero Section */}
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-5xl font-starjedi text-cyan-400 tracking-wider mb-4">
            THE ORIGINS LEGEND
          </h1>
          
          <p className="text-base text-gray-300 max-w-2xl mx-auto leading-relaxed mb-6">
            Preserving the authentic Star Wars Galaxies experience with modern technology and a thriving community.
          </p>

          {/* Server Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 max-w-xl mx-auto">
            {[
              { label: "Players", value: "2,500+", icon: <Users className="w-4 h-4" /> },
              { label: "Uptime", value: "99.9%", icon: <Server className="w-4 h-4" /> },
              { label: "Years", value: "3+", icon: <Clock className="w-4 h-4" /> },
              { label: "Content", value: "500+", icon: <Star className="w-4 h-4" /> }
            ].map((stat, index) => (
              <div
                key={index}
                onMouseEnter={playHoverSound}
                className="holographic-border bg-slate-900/60 border border-cyan-500/30 rounded-lg p-3 text-center hover:border-cyan-400/50 transition-all duration-300 group pulse-glow"
              >
                <div className="text-cyan-400 mb-1 group-hover:scale-110 transition-transform duration-300 flex justify-center">
                  {stat.icon}
                </div>
                <div className="text-lg font-bold text-white mb-1">{stat.value}</div>
                <div className="text-xs text-gray-400">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Mission Section */}
        <div className="mb-6">
          <div className="bg-slate-900/60 border border-cyan-500/30 rounded-lg p-4 max-w-3xl mx-auto">
            <p className="text-sm text-gray-300 text-center">
              Preserving the authentic Star Wars Galaxies experience with modern technology and custom content.
            </p>
          </div>
        </div>

        {/* Features Section */}
        <div className="mb-8">
          <h2 className="text-2xl font-starjedi text-cyan-400 text-center mb-6 tracking-wider">
            KEY FEATURES
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {[
              {
                icon: <Sword className="w-6 h-6" />,
                title: "Pre-CU Combat",
                description: "Original combat system with skill trees and Jedi unlock."
              },
              {
                icon: <Gamepad2 className="w-6 h-6" />,
                title: "Crafting System",
                description: "Resource surveying and factory crafting mechanics."
              },
              {
                icon: <Users className="w-6 h-6" />,
                title: "Active Community",
                description: "Thriving player base with guilds and events."
              }
            ].map((feature, index) => (
              <div
                key={index}
                onMouseEnter={playHoverSound}
                className="bg-slate-900/60 border border-cyan-500/30 rounded-lg p-4 hover:border-cyan-400/50 transition-all duration-300 group text-center"
              >
                <div className="text-cyan-400 mb-3 group-hover:scale-110 transition-transform duration-300 flex justify-center">
                  {feature.icon}
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">
                  {feature.title}
                </h3>
                <p className="text-sm text-gray-300">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>





      </div>
    </div>
  )
}
